import { ProjectRecord } from "@/types";
import { CONTRACTOR_ENROLLMENT_STATUS_ITEMS } from "@/constants";

export const getEnrollmentStatusItems = (
  enrollmentStatus: ProjectRecord["enrolmentStatus"]
) => {
  return CONTRACTOR_ENROLLMENT_STATUS_ITEMS.map((item) => {
    if (enrollmentStatus === "correction_needed") {
      return {
        ...item,
        disabled:
          item.value !== "contractor_updated" &&
          item.value !== "correction_needed",
      };
    }
    return item;
  });
};

export const getEnrollmentStatusChangeAllowed = (
  enrollmentStatus: ProjectRecord["enrolmentStatus"]
) => {
  return enrollmentStatus === "correction_needed";
};
